import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "restaurant_categories/";

const getCategoriesNames = () => axios.get(baseURL + "categories_names");


export {
    getCategoriesNames
}
